import { NoiseReduction } from "@/hooks/transcriber/types";

export const getAudioReactMediaRecorderOptions = (
  noiseReduction: NoiseReduction,
  noiseSuppression: boolean,
): MediaTrackConstraints => {
  const value = {
    autoGainControl: noiseReduction == NoiseReduction.FAR_FIELD,
    echoCancellation: false,
    noiseSuppression: noiseSuppression,
  };
  return value;
};
